import React from 'react';
import { ErrorMainContainer } from '../styles/ErrorPageStyle';

const ErrorPage = () => {
  return <ErrorMainContainer>Oops. . . This page doesn't exist</ErrorMainContainer>;
};

export default ErrorPage;
